import { useMutation, useQuery } from "react-query";
import { PSLService } from "src/app/preferredSuppliers/domains/psl.service";
import { UserInteractionType } from "src/app/shared/domains/user/userInteractionType";
import { DocumentFlowService } from "../domains/documentFlow/documentFlow.service";
import { MasterService } from "src/app/shared/domains/master/master.service";
import { PRPOItemService } from "../domains/prpo/item.service";

export const useResubmitPrHook = (onError: Function) => {
    return useMutation((doFlowItems: any[]) => DocumentFlowService.newSaveDocFlow(UserInteractionType.EditedRequestCockpit, doFlowItems),
        {
            onError: (error, variables, context) => {
                onError() // this is to stop loading when sap call fails
            }
        })
}

export const useCreateFairmrktRfq = () => {
    return useMutation(({ prNo, itemNo }: { prNo: string, itemNo?: string }) => DocumentFlowService.initiateFairmrktRfq(prNo, itemNo)
    )
}


export const useFetchAccTabData = (prNo: string, poNo: string, systemAlias: string) => {
    return useQuery("accountsTab" + prNo + poNo + systemAlias, () => DocumentFlowService.getAccountsTabData(prNo, poNo, systemAlias), { staleTime: Infinity })
}

export const useFetchPricingCondData = (systemAlias: string, aribaPR: string, prNo: string) => {
    return useQuery("pricingConditions" + prNo + aribaPR + systemAlias, () => DocumentFlowService.fetchPRPricing(systemAlias, aribaPR, prNo), { staleTime: Infinity })
}

// used to net reversed Goods Receipts, since DocFlowItem.GrQty can be stale after a GR reversal in SAP
export const useFetchGRItems = (prNo: string, poNo: string, systemAlias: string) => {
    return useQuery("grItemsForAccTab" + prNo + poNo + systemAlias, () => PRPOItemService.fetchGRItems({ poNo, prNo, systemAlias }), { staleTime: Infinity })
}

export const useFetchPslMaterial = (query: any) => {
    return useQuery("nbsPslMaterialData" + JSON.stringify(query),
        () => PSLService.fetchMaterialsForRc(query), { staleTime: Infinity, retry: 2 });
};

export const useFetchCandexData = (sessionId: string) => {
    return useQuery("candexData" + sessionId, () => DocumentFlowService.getCandexData(sessionId), { staleTime: 2000 })
}

export const useFetchcXMLData = (sessionId: string) => {
    return useQuery("cXmlData" + sessionId, () => DocumentFlowService.getLslCXMLData(sessionId), { staleTime: 2000 })
}

export const useFetchPunchoutCatDetails = (compCode: string, purchOrg: string, supplier: string) => {
    return useQuery("PunchoutCatDetails" + compCode + purchOrg + supplier, () => MasterService.getPunchoutCatalogDetails(compCode, purchOrg, supplier), { staleTime: Infinity })
}

export const useGetLslUrlData = () => {
    return useMutation((xmlData: string) => DocumentFlowService.getLslUrl(xmlData))
}

export const useGetcXMLUrl= () => {
    return useMutation(({ xmlData, url }: { xmlData: string, url: string }) => DocumentFlowService.getcXMLUrl(xmlData, url))
}


